/**
 * Sidebar Navigation Configuration — lox247
 *
 * Items are filtered at runtime by feature flags and user role.
 *
 * Two nav surfaces:
 *  - **Buyer** (role = 'user'): Catalogue, Cart, My Orders
 *  - **Admin** (role = 'admin', auto-promoted from ADMIN_EMAILS env var):
 *    the buyer items plus Products, Customers, Orders, Invoices
 *
 * Unapproved buyers (`customers.approved=false`) are redirected to
 * `/pending-approval` at the route level — they still see the dashboard
 * shell, just no catalogue content.
 *
 * See `src/server/middleware/admin.ts` for the email→role auto-promotion.
 */
import type { LucideIcon } from 'lucide-react'
import {
  ShoppingBag,
  ShoppingCart,
  Package,
  Users,
  ClipboardList,
  Receipt,
  Home,
} from 'lucide-react'

export interface NavItem {
  /** Route path */
  to: string
  /** Display label */
  label: string
  /** Lucide icon component */
  icon: LucideIcon
  /** Only show if this feature flag is true (from features config) */
  feature?: string
  /** Minimum role required. Omit = visible to all roles. */
  minRole?: 'user' | 'manager' | 'admin'
  /** Only show when Builder Mode is enabled. */
  builderOnly?: boolean
}

export interface NavSection {
  label: string
  items: NavItem[]
  defaultCollapsed?: boolean
  builderOnly?: boolean
}

export const NAV_SECTIONS: NavSection[] = [
  {
    label: 'Trade',
    items: [
      { to: '/dashboard', label: 'Home', icon: Home },
      { to: '/dashboard/catalogue', label: 'Catalogue', icon: ShoppingBag },
      { to: '/dashboard/cart', label: 'Cart', icon: ShoppingCart },
      { to: '/dashboard/my-orders', label: 'My orders', icon: ClipboardList },
    ],
  },
  {
    label: 'Admin',
    items: [
      { to: '/dashboard/admin/products', label: 'Products', icon: Package, minRole: 'admin' },
      { to: '/dashboard/admin/customers', label: 'Customers', icon: Users, minRole: 'admin' },
      { to: '/dashboard/admin/orders', label: 'Orders', icon: ClipboardList, minRole: 'admin' },
      { to: '/dashboard/admin/invoices', label: 'Invoices', icon: Receipt, minRole: 'admin' },
    ],
  },
]
